import axiosInstance from "../../api/AxiosConfig";

/**
 * Sends a PATCH request to update user data on the server.
 *
 * Uses a pre-configured Axios instance to send updated user information
 * to the `user/update/` endpoint. Also handles loading state via the
 * provided `setIsUserDataLoading` callback. Returns the server's response
 * or the error if the request fails.
 *
 * @async
 * @function
 * @param {Object} updateData - Object containing the user fields to update.
 * @param {Function} setIsUserDataLoading - Function to control loading state (e.g., React state setter).
 * @returns {Promise<Object>} Axios response object if successful, or error object if request fails.
 *
 * @example
 * const updatedInfo = {
 *   first_name: "John",
 *   last_name: "Doe"
 * };
 *
 * updateUser(updatedInfo, setIsUserDataLoading)
 *   .then(response => {
 *     console.log("User updated:", response.data);
 *   })
 *   .catch(error => {
 *     console.error("Update failed:", error);
 *   });
 */
const updateUser = async (updateData, setIsUserDataLoading) => {
  setIsUserDataLoading(true);
  try {
    const response = await axiosInstance.patch(`user/update/`, updateData);
    return response;
  } catch (error) {
    return error;
  } finally {
    setIsUserDataLoading(false);
  }
};

export default updateUser;
